export default "__VITE_ASSET__13816b07__"